import React from 'react';
import { useSettings } from '@wix/yoshi-flow-editor/tpa-settings/react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { Button, PRIORITY } from 'wix-ui-tpa/Button';
import { classes } from './BuyButton.st.css';
import settingsParams from '../../../settingsParams';
import { useControllerProps } from '../../ControllerContext';
import { useState } from '../../stores';

const BuyButton = () => {
  const {
    state: { checkout: checkoutState },
  } = useState();
  const settings = useSettings();
  const { isPreview } = useEnvironment();
  const { product, currencyCode } = useControllerProps().giftCardStore;
  const {
    createCheckout,
    reportCheckout,
    checkout,
    navigateToCheckout,
    creatingCheckout,
  } = useControllerProps().giftCardCheckoutStore;

  if (checkout) {
    checkout.id && navigateToCheckout(checkout.id);
  }

  return (
    <Button
      data-hook="rise-gift-card-buy-button"
      className={classes.button}
      fullWidth
      upgrade
      disabled={isPreview || creatingCheckout}
      priority={PRIORITY.primary}
      onClick={() => {
        if (product) {
          createCheckout(
            product.product_id,
            checkoutState.purchaseOptions,
            currencyCode || '',
          );
          reportCheckout({
            product,
            purchase_options: checkoutState.purchaseOptions,
            currencyCode: currencyCode || '',
          });
        }
      }}
    >
      {settings.get(settingsParams.buyButtonText)}
    </Button>
  );
};

export default BuyButton;
